// extracted by mini-css-extract-plugin
export default {"container":"dessert_container__64726","title":"dessert_title__zbgV7"};